export default "__VITE_ASSET__C4GHK3uC__"